import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";

import type { FieldDTO } from "../../../types/Field";
import type { RootState } from "../../store";

interface SelectedFieldState {
  field?: FieldDTO | undefined;
}

export const selectField = createSelector(
  (state: RootState) => state,
  (state) => state.selectedField,
);

export const selectedFieldSlice = createSlice({
  name: "field",
  initialState: { field: undefined } as SelectedFieldState,
  reducers: {
    updateSelectedField: (state, action: PayloadAction<FieldDTO>) => {
      state.field = action.payload;
    },
    //TODO: use combineReducers to clear dataset and field states in one action
    clearSelectedField: (state) => {
      state.field = undefined;
    },
  },
});

export const { updateSelectedField, clearSelectedField } = selectedFieldSlice.actions;
